import React from "react";
import clsx from "classnames";

import { motion, AnimateSharedLayout } from "framer-motion";

// material-ui
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
// import Button from "@material-ui/core/Button";

import SvgIcon from "components/SvgIcon";

// core components
import { container } from "assets/jss/material-kit-pro-react.jsx";

import { appUrl } from "../../../../config";

const mediaUrl = `${appUrl}/media/optafloor/features`;

const featureList = [
  {
    icon: <SvgIcon src={`${mediaUrl}/real-time-production-monitoing.svg`} size={50} />,
    iconWhite: <SvgIcon src={`${mediaUrl}/real-time-production-monitoing-white.svg`} size={50} />,
    title: "Real-time Production Monitoring",
    subtitle:
      "Drive performance optimization with real-time production visibility, identifying bottlenecks in real time for continuous production improvement.",
    bgLight: "#E3F3E3",
    bgDark: "#67BB6B",
  },
  {
    icon: <SvgIcon src={`${mediaUrl}/predictive-qality-control-system.svg`} size={50} />,
    iconWhite: <SvgIcon src={`${mediaUrl}/predictive-qality-control-system-white.svg`} size={50} />,

    title: "Predictive Quality Control System",
    subtitle: "Predict and prevent quality failures with real-time alerts enabling teams to take action fast.",
    bgLight: "#FCE9EE", //tomatoRed
    bgDark: "#ee91a8",
  },
  {
    icon: <SvgIcon src={`${mediaUrl}/automated-live-line-balancing.svg`} size={50} />,
    iconWhite: <SvgIcon src={`${mediaUrl}/automated-live-line-balancing-white.svg`} size={50} />,
    title: "Automated Live Line Balancing",
    subtitle:
      "Optimize efficiency and productivity by allocating the operators in the most efficient ways using advanced algorithms.",
    bgLight: "#DDFBFF", //turqoise
    bgDark: "#00C3DB",
  },
  {
    icon: <SvgIcon src={`${mediaUrl}/down-time-minimization-solution.svg`} size={50} />,
    iconWhite: <SvgIcon src={`${mediaUrl}/down-time-minimization-solution-white.svg`} size={50} />,
    title: "Downtime Minimization Solution",
    subtitle:
      "Identify the source of downtime, quantify them and discourage them through our innovative escalation Plan.",
    bgLight: "#FFF1E6", //orange
    bgDark: "#FF9032",
  },
  {
    icon: <SvgIcon src={`${mediaUrl}/employee-performence-optimization.svg`} size={50} />,
    iconWhite: <SvgIcon src={`${mediaUrl}/employee-performence-optimization-white.svg`} size={50} />,
    title: "Employee Performance Optimization",
    subtitle:
      "Achieving higher factory efficiency is not possible without excellent operator performance. Adopt scientific approach to optimize operator performance.",
    bgLight: "#EDF5FD", //skyblue
    bgDark: "#63acee",
  },
  {
    icon: <SvgIcon src={`${mediaUrl}/end-to-end-factory-digitalization.svg`} size={50} />,
    iconWhite: <SvgIcon src={`${mediaUrl}/end-to-end-factory-digitalization-white.svg`} size={50} />,
    title: "End to end Factory Digitalization",
    subtitle:
      "OptaFloor is not limited to any one department as true digital transformation requires technological change across the enterprise value chain.",
    bgLight: "#E9E1F5", // purple
    bgDark: "#916DD0",
  },
];

const transition = {
  duration: 1,
  type: "spring",
  bounce: 0.25,
};

const iconVariants = {
  rest: idx => ({
    backgroundColor: featureList[idx]?.bgLight,
  }),
  hover: idx => ({
    backgroundColor: featureList[idx]?.bgDark,
  }),
};

const containerVariant = {
  hover: {
    y: -10,
  },
};

const useStyles = makeStyles(theme => ({
  container,
  marginTop: {
    marginTop: "240px",
  },
  title: {
    margin: "80px 0",
  },
  margin: {
    margin: "1rem 0",
  },
  textCenter: {
    textAlign: "center",
  },
  featureContainer: {
    // marginTop: "80px",
  },
  card: {
    boxShadow: theme.shadows[1],
    backgroundColor: "white",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1.2em",
  },
  iconContainer: {
    backgroundColor: "#DDF7F0",
    width: 100,
    height: 100,
    borderRadius: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cardActions: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "1em",
  },
}));

const Features = () => {
  const classes = useStyles();
  const [selected, setSelected] = React.useState(null);

  return (
    <div className={clsx(classes.container, classes.marginTop)}>
      <div className={classes.title}>
        <Typography className={classes.textCenter} variant="h4">
          An integrated solution designed to solve everyday problems manufacturers face on the factory floor
        </Typography>
      </div>

      <AnimateSharedLayout>
        <motion.div layout className={clsx(classes.featureContainer)}>
          <Grid container justify="center" spacing={6}>
            {featureList.map(({ title, subtitle, icon, iconWhite }, idx) => (
              <Grid key={idx} item xs={12} sm={4} zeroMinWidth>
                <motion.div
                  layout
                  className={classes.card}
                  onMouseEnter={() => setSelected(idx)}
                  onMouseLeave={() => setSelected(null)}
                  initial={`rest`}
                  whileHover={`hover`}
                  variants={containerVariant}>
                  <div className={classes.cardContent}>
                    <motion.div
                      className={classes.iconContainer}
                      custom={idx}
                      variants={iconVariants}
                      transition={transition}>
                      {selected === idx ? iconWhite : icon}
                    </motion.div>
                    <div className={classes.margin}>
                      <Typography className={classes.textCenter} variant="h5">
                        {title}
                      </Typography>
                    </div>
                    <div className={classes.margin}>
                      <Typography className={classes.textCenter} variant="subtitle2">
                        {subtitle}
                      </Typography>
                    </div>
                  </div>

                  {/* <div className={classes.cardActions}>
                    <Button color="primary" variant="contained">
                      Learn More
                    </Button>
                  </div> */}
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </AnimateSharedLayout>
    </div>
  );
};

export default Features;
